import { CssBaseline, ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { ApiFout } from './api/fouten.ts';
import { App } from './App.tsx';
import { SessieProvider } from './auth/SessieContext.tsx';
import { MeldingenProvider } from './componenten/Meldingen.tsx';
import { thema } from './thema.ts';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (poging, fout) => !(fout instanceof ApiFout && fout.status < 500) && poging < 2,
      refetchOnWindowFocus: false,
      staleTime: 10_000,
    },
  },
});

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={thema}>
        <CssBaseline />
        <BrowserRouter>
          <MeldingenProvider>
            <SessieProvider>
              <App />
            </SessieProvider>
          </MeldingenProvider>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
